import {queryService} from "@/api/services";
import useAuthStore from "@/store/use-auth-store.ts";
import {useMutation} from "@tanstack/react-query";

// Hook for subscription create checkout session endpoint
export const useCreateCheckoutSession = () => {
  const {user} = useAuthStore();

  const mutation = useMutation({
    mutationFn: ({
                   planId,
                 }: {
      planId: string;
    }) => queryService.createCheckoutSession(planId, user!.email, user!._id),
    onError: (error) => {
      console.error("Create chekcout session error:", error);
    },
  });

  return {
    createCheckoutSession: mutation.mutateAsync,
    isCreating: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  };
};

// Hook for customer portal redirect
export const useCustomerPortal = () => {
  const mutation = useMutation({
    mutationFn: ({
      subscriptionId,
      targetPricingPlanId,
    }: {
      subscriptionId: string;
      targetPricingPlanId: string;
    }) => queryService.getCustomerPortalUrl(subscriptionId, targetPricingPlanId),
    onError: (error) => {
      console.error("Customer portal error:", error);
    },
  });

  return {
    getCustomerPortalUrl: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  };
};

// Hook for comparing the user's current vs. previous pricing plan.
// Fires POST /subscription/compare-pricing-plan with no payload; the
// backend reports whether the subscription changed (no_change/upgrade/downgrade).
export const useComparePricingPlan = () => {
  const mutation = useMutation({
    mutationFn: () => queryService.comparePricingPlan(),
    onError: (error) => {
      console.error("Compare pricing plan error:", error);
    },
  });

  return {
    comparePricingPlan: mutation.mutateAsync,
    isComparing: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  };
};

// Hook for payment method update redirect
export const usePaymentMethodUpdate = () => {
  const mutation = useMutation({
    mutationFn: () => queryService.getPaymentMethodUpdateUrl(),
    onError: (error) => {
      console.error("Payment method update error:", error);
    },
  });

  return {
    getPaymentMethodUpdateUrl: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  };
};
